import { ApiError } from './ApiError';

type SetContactEmailResponse = {
  pendingContactEmail?: string;
  alreadyActive?: boolean;
};

/**
 * Stage a contact email for verification. The backend emails a confirmation
 * link; the address only becomes active once that link is clicked, so a
 * successful call means "check your inbox", not "done". Throws ApiError so
 * callers can tell the 429 rate limit apart from validation failures.
 */
export const setContactEmail = async (
  email: string,
  userToken: string
): Promise<SetContactEmailResponse> => {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/api/user/contact-email`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userToken}`,
      },
      body: JSON.stringify({ email }),
    }
  );

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new ApiError(
      errorData.error || `Request failed: ${response.status}`,
      response.status
    );
  }

  return await response.json();
};

/** Hide the dashboard add-your-email nudge for good. Fire-and-forget. */
export const dismissContactEmailNudge = async (
  userToken: string
): Promise<void> => {
  await fetch(
    `${process.env.REACT_APP_API_URL}/api/user/contact-email-nudge-dismissed`,
    {
      method: 'POST',
      headers: { Authorization: `Bearer ${userToken}` },
    }
  );
};
